var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-currency',{attrs:{"error-messages":_vm.errors['currency'],"hide-details":"auto"},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}})}
var staticRenderFns = []

export { render, staticRenderFns }